if (!window.customElements.get("discount-countdown")) {
  var DiscountCountdown = class extends HTMLElement {
    constructor() {
      super();
      this._endingTime = this.getAttribute("data-ending-time");
      this._dateEl = this.querySelector("[data-countdown-day]");
      this._hourEl = this.querySelector("[data-countdown-hour]");
      this._minuteEl = this.querySelector("[data-countdown-minute]");
      this._secondsEl = this.querySelector("[data-countdown-seconds]");
      this._countdownIntervalFunction = this._handleCountdown.bind(this);
    }
    connectedCallback() {
      const targetTime = new Date(this._endingTime).getTime()
      // 获取当前时间
      const currentTime = new Date().getTime();
      // 获取时间差
      const diffTime = targetTime - currentTime;
      if (diffTime <= 0)  return;
      this._interval = setInterval(this._countdownIntervalFunction, 1000);
    }
    disconnectedCallback() {
      clearInterval(this._interval);
    }
    _formatNumber(num) {
      if (num < 10) {
        return `0${num}`;
      } else {
        return num;
      }
    }
    _handleCountdown() {
      // 获取目标时间
      // const targetTime = new Date(this._endingTime).getTime();
      const targetTime = new Date(this._endingTime).getTime()
      // 获取当前时间
      const currentTime = new Date().getTime();
      // 获取时间差
      const diffTime = targetTime - currentTime;
      if (diffTime <= 0) {
        // 置零
        this._dateEl.html("00");
        this._hourEl.html("00");
        this._minuteEl.html("00");
        this._secondsEl.html("00");
        return;
      }
      // 计算时间差day
      const day = Math.floor(diffTime / 86400000);
      const dayRemain = Math.floor(diffTime % 86400000);
      // 计算小时数
      const hours = Math.floor(dayRemain / 3600000);
      const hoursRemain = Math.floor(dayRemain % 3600000);
      // 计算分钟数
      const minutes = Math.floor(hoursRemain / 60000);
      const minutesRemain = Math.floor(hoursRemain % 60000);
      // 计算秒数
      const seconds = Math.floor(minutesRemain / 1000);
      // 更新
      this._dateEl.innerHTML = this._formatNumber(day);
      this._hourEl.innerHTML = this._formatNumber(hours);
      this._minuteEl.innerHTML = this._formatNumber(minutes);
      this._secondsEl.innerHTML = this._formatNumber(seconds);
    }
  };
  window.customElements.define("discount-countdown", DiscountCountdown);
}